import { Helmet } from "react-helmet";
import Header from "../Header/Header";

import "../Snack/Snack.css";

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>1goodthing - Privacy Policy</title>
        <meta
          name="description"
          content="1goodthing Privacy Policy"
        />
      </Helmet>
      <div className="App">
        <Header showHome={true} />
        <h2>Privacy Policy</h2>
        <div className="snack">
          <div className="snack-card">
            <h2>Privacy Policy</h2>
            <p>
              Your privacy is important to us. By default, all your entries are
              stored locally on your device and are never sent to our servers.
            </p>
            <p>
              If you choose to sign in and purchase the premium Cloud Sync
              feature, your entries will be stored securely on our servers so
              you can access them across devices. This data is only collected
              with your explicit consent and is used solely to provide the
              Cloud Sync service.
            </p>
            <p>
              If you backup the app to iCloud it's stored there as well. See
              Apple's privacy policy for more info.
            </p>
            <p>
              Your continued use of the app will be regarded as acceptance of
              the practices around privacy and personal information. If you have
              any questions about how we handle user data and/or personal
              information, feel free to contact us.
            </p>
            <p>This policy is effective as of March 16th 2026</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
